import { useLazyQuery } from '@apollo/client';
import { documentSignRequestQuery } from './query';
export function useDocumentForSignRequest(documentId) {
    const [loadDocument] = useLazyQuery(documentSignRequestQuery, {
        variables: { documentId },
    });
    return { loadDocument };
}
